module.exports = "/static/assets/d9e0fd6da7031be3ed69ef361ad28792.jpg";